import { IconButton, Tooltip } from "@mui/material";

const AssociationSelectorButton = ({ tooltip, icon, onClick, disabled }) => {
  return (
    <Tooltip title={tooltip}>
      <IconButton
        onClick={onClick}
        disabled={disabled}
        size="small"
        variant="text"
        sx={{
          borderRadius: "8px",
          border: "1px solid #dde0e4",
          ".MuiButton-icon": {
            mr: 0.2,
          },
          ".MuiSvgIcon-root": {
            fontSize: "14px !important",
          },
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export default AssociationSelectorButton;
